import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import DatePicker from 'react-datepicker2';

export default class Annual extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/annual/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/annual/save", {
            organizationId: this.state.data.global.company.id,
            title: this.state.data.record.title,
            taxPercent: this.state.data.record.taxPercent,
            from: this.state.data.record.from,
            to: this.state.data.record.to
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="container">
            <div className="panel panel-info center-block">
                <div className="panel-heading">
                    <span className="panel-title acc-txt-9"><strong>تنظیمات سال مالی</strong></span>
                </div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="title1">نرخ مالیات <span className="red">*</span></label>
                                <div>
                                    <input defaultValue={this.state.data.record.taxPercent} onChange={e => this.state.data.record.taxPercent = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm ng-pristine ng-untouched persian-date" type="text" style={{ "direction": "ltr" }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="title1">شروع سال مالی <span className="red">*</span></label>
                                <div>
                                    <DatePicker
                                        inputReadOnly={true}
                                        className="form-control input-sm persian-date"
                                        placeholder={"تاریخ"}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => { this.state.data.record.from = e }}
                                        value={this.getFormatedDateForDatePicker(this.state.data.record.from)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="title1">انتهای سال مالی <span className="red">*</span></label>
                                <div>
                                    <DatePicker
                                        inputReadOnly={true}
                                        className="form-control input-sm persian-date"
                                        placeholder={"تاریخ"}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => { this.state.data.record.to = e }}
                                        value={this.getFormatedDateForDatePicker(this.state.data.record.to)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label for="inputFinanYearName" className="title1">عنوان سال مالی <span className="red">*</span></label>
                                <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                            </div>
                        </div>
                    </div>
                    <div style={{ "margin-bottom": "20px" }} ></div>
                    <div className="panel panel-default center-block iransans" style={{ "font-size": "12pt", "background-color": "whitesmoke", "padding": "10px" }}>
                        <div className="row">
                            <div className="col-xs-2">
                                <button onClick={e => this.save(e)} className="btn btn-success">ذخیره</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}